var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItrvlLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 461.28 199.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M98.85,48.07h.07V0L88.77,42.82A57.77,57.77,0,0,0,42,90.39l6.53-1.55A51.59,51.59,0,0,1,98.85,48.07"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.36,100.37H0l42.23,10a57.79,57.79,0,0,0,48,46.18l-1.55-6.5a51.6,51.6,0,0,1-41.3-49.69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M100.27,151.05l.1,0v48.2L110.63,156a57.79,57.79,0,0,0,45.06-46.88l-6.55,1.56a51.58,51.58,0,0,1-48.87,40.37"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M109.11,42.85l1.57,6.6A51.6,51.6,0,0,1,150.35,99l0-.07h48.92l-43.87-10.4a57.79,57.79,0,0,0-46.31-45.67"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#639fc3",
    d: "M98.17,86.78a8,8,0,1,0-8-8,8,8,0,0,0,8,8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#639fc3",
    d: "M107.35,106.74c0-6.48-4.82-10.59-9-14.81h-.09l0,0c-4.21,4.2-9,8.31-9,14.76,0,7.62,5.58,11.18,9,24.34l.06.2v.3a.83.83,0,0,1,0-.15.83.83,0,0,0,0,.15v-.3c3.4-13.33,9-16.88,9-24.54"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M230.61,53.85a5,5,0,0,0-5,5.08,4.94,4.94,0,0,0,5,5,5,5,0,1,0,0-10.08"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M233.9,131.89h.87v-59h-8.23v51.67a7.37,7.37,0,0,0,7.36,7.36"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M297.8,124.56a22,22,0,0,1-6.1.75c-4,0-7.26-1.35-9.29-3.89-1.27-1.58-2.44-3.81-2.44-9.37V80.71h16.87V72.86H280V57.07h-.49a7.76,7.76,0,0,0-7.75,7.75v8H262.8a7.37,7.37,0,0,0-7.36,7.36v.49h16.29v31.08c0,6.57,1.25,11.06,4,14.57,4.71,5.92,12,6.8,15.92,6.8a28.63,28.63,0,0,0,7.67-1l.4-.14-1.45-7.57Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M352.81,71.58a23.91,23.91,0,0,0-16.71,6.66L335,79.38V72.86h-1.62a6.63,6.63,0,0,0-6.62,6.61v45.7a6.73,6.73,0,0,0,6.72,6.72H335v-40l0-.12c3.1-7.38,10.2-12.34,17.66-12.34a31.19,31.19,0,0,1,3.36.12l.49.08,1.17-7.72-.48-.08c-.84-.14-3.48-.26-4.41-.26"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M404.88,118.52,385.43,76.37a6.09,6.09,0,0,0-5.49-3.51h-5.11l27.44,59h5.34l27.32-59h-5.12a6.06,6.06,0,0,0-5.48,3.5Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M460.79,40.52a7.75,7.75,0,0,0-7.74,7.75v83.62h2.33a5.9,5.9,0,0,0,5.9-5.9V40.52Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItrvlLogoWhite);
export default __webpack_public_path__ + "static/media/itrvl_logo--white.94ca1c57261957535bfb1c408626a85c.svg";
export { ForwardRef as ReactComponent };